import { render, staticRenderFns } from "./ExternalLinks.vue?vue&type=template&id=0a944f5a&scoped=true"
import script from "./ExternalLinks.vue?vue&type=script&lang=js"
export * from "./ExternalLinks.vue?vue&type=script&lang=js"
import style0 from "./ExternalLinks.vue?vue&type=style&index=0&id=0a944f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a944f5a",
  null
  
)

export default component.exports